import React from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputField from "../../form/InputField";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import LoadingButton from "../../form/LoadingButton";
import SubmitButton from "../../form/SubmitButton";

export interface VariantCategoryFormData {
  languages: {
    languageCode: string;
    title: string;
  }[];
}

interface Props {
  defaultValues: VariantCategoryFormData;
  id:number;
  onSubmitSuccess?: () => void;
}

const UpdateVariantCategoryForm: React.FC<Props> = ({ defaultValues, id,onSubmitSuccess }) => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<VariantCategoryFormData>({
    defaultValues, // prefill the form with provided values
  });

  
      const {loading,updateResource} = useUpdateResource();
  
    const onSubmit: SubmitHandler<VariantCategoryFormData> = async (data) => {
          await  updateResource(`variant-category/${id}`, 
                    {languages:data.languages.map(la=>({languageCode:la.languageCode,name:la.title}))}
                    , 
                    "admin",{
                    method: "PUT",
                    successMessage: t("update_success"),
                    invalidateQueries:["variant-category-by-admin"],
                    });
          if (onSubmitSuccess) onSubmitSuccess();
    };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="grid sm:grid-cols-2 gap-4"
    >
      {/* English Brand Name */}
      <InputField
        placeholder=""
        label={t("title_en")}
        register={register("languages.0.title", {
          required: t("required_field"),
        })}
        error={errors.languages?.[0]?.title}
      />

      {/* Arabic Brand Name */}
      <InputField
        placeholder=""
        label={t("title_ar")}
        register={register("languages.1.title", {
          required: t("required_field"),
        })}
        error={errors.languages?.[1]?.title}
      />

       {
              loading
              ?
              <LoadingButton/>
              :
              <SubmitButton label={t("update")} />
      }
    </form>
  );
};

export default UpdateVariantCategoryForm;
